"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectedUpgradeDataPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var connectedUpgradeDataPropsInterface = {
  upgradeData: _propTypes.default.shape({
    app: _propTypes.default.string.isRequired,
    screen: _propTypes.default.string.isRequired,
    source: _propTypes.default.string.isRequired,
    trialId: _propTypes.default.number
  }).isRequired
};
exports.connectedUpgradeDataPropsInterface = connectedUpgradeDataPropsInterface;